<mat-card class="d-flex justify-content-between mb-2">
	<div *ngIf="item.new" class="new-badge">
		<span>NEW</span>
	</div>

	<ng-container *ngIf="status === '200'">
		<button mat-stroked-button class="bg-white" (click)="router.navigateByUrl('/download-area')">
			<strong class="mr-1">{{ length }}</strong>
			{{ item.message }}
		</button>
	</ng-container>

	<ng-container *ngIf="status !== '200'">
		<div class="d-flex justify-content-between align-items-center">
			<button mat-flat-button class="bg-white" disabled>
				<strong class="mr-1">{{ length }}</strong>
				<i *ngIf="status !== '200' && status !== '204'" class="fas fa-exclamation-circle ico-error"></i>
				{{ item.message }}
			</button>
		</div>
	</ng-container>

	<div class="d-flex flex-column text-center justify-content-center">
		<span class="d-block">Last edit:</span>
		<span>{{ item.created_at }}</span>
	</div>
</mat-card>
